<kendo-dialog *ngIf="eligibilityOpened"
    title="{{'VERIFY-MEDICAID-ELIGIBILITY' | translate}} - {{eligibilityData.patientName}}" [width]="550"
    (close)="closeEligibility()">
    <div class="pl-3 pt-3">
        <!--Medicaid-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'MEDICAID-ID' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span *ngIf="eligibilityData.medicaidNumber">{{eligibilityData.medicaidNumber}}
                </span>
            </div>
        </div>
        <!--Medicaid Eligibility-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'MEDICAID-ELIGIBILITY' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6" *ngIf="eligibilityData.eligible !== null">
                <span *ngIf="eligibilityData.eligible" class="eligible p-2"><i
                        class="fas fa-user-check"></i>&nbsp;{{'ELIGIBLE' | translate}}
                </span>
                <span *ngIf="!eligibilityData.eligible" class="not-eligible p-2"><i
                        class="fas fa-user-slash"></i>&nbsp;{{'RECORD-STATUS-NOT-ELIGIBLE' | translate}}
                </span>
            </div>
        </div>
        <!--Start Date-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'START-DATE' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span
                    *ngIf="eligibilityData.eligibilityStartDate">{{intl.formatDate(intl.parseDate(eligibilityData.eligibilityStartDate),'d')}}
                </span>
            </div>
        </div>
        <!--End Date-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'END-DATE' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span
                    *ngIf="eligibilityData.eligibilityEndDate">{{intl.formatDate(intl.parseDate(eligibilityData.eligibilityEndDate),'d')}}
                </span>
            </div>
        </div>
        <!--Disenrollment Date-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'DISENROLLMENT-DATE' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span
                    *ngIf="eligibilityData.disenrollDate">{{intl.formatDate(intl.parseDate(eligibilityData.disenrollDate),'d')}}
                </span>
            </div>
        </div>
        <!--Payer Name-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'ELIGIBILITY-INSURER-NAME' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span *ngIf="eligibilityData.insurerName">{{eligibilityData.insurerName}}
                </span>
            </div>
        </div>
        <!--Last checked-->
        <div class="row">
            <div class="col-6">
                <label class="k-form-field w-100">
                    <span class="k-text-uppercase dark">
                        {{ 'ELIGIBILITY-LAST-CHECKED' | translate }}
                    </span>
                </label>
            </div>
            <div class="col-6">
                <span
                    *ngIf="eligibilityData.lastChecked">{{intl.formatDate(intl.parseDate(eligibilityData.lastChecked),'d')}}
                </span>
                <div *ngIf="eligibilityData.offline" class="not-eligible p-2 text-center"><i
                        class="fas fa-signal-slash"></i>&nbsp;{{'ELIGIBILITY-SERVICE-OFFLINE' | translate}}
                </div>
            </div>
        </div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeEligibility()">{{'CLOSE' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>